import store from "../../store";

export const getTextNodeClaroSportsGuia = () => {
  const { nodes = [] } = store.getState().navbar || {};
  const tvNode = nodes.find(node => node.code === "guia") || {};
  const claroSportNode = nodes.find(node => node.code === "clarosports") || {};

  return [tvNode.text, claroSportNode.text] || [];
}

export const getNodeFrom = () => {
  const { from = {} } = store.getState().navbar || {};
  const nodeFrom = from.node_initial;

  return nodeFrom || "";
}



// WEBPACK FOOTER //
// ./src/containers/App/utils.js